// import axios from "./axiosInstance";

// const ProfileAPI = {
//   postProfile: (slug) => axios.post(`profile?slug=${slug}`),
// };

// export default ProfileAPI;

import axios from "./axiosInstance";

const ProfileAPI = {
    postProfile: (userId) =>
        axios.post("/profile", {
            user_id: userId,
        }),
};

export default ProfileAPI;
